import "../scss/style.scss";
import "scroll-hint/css/scroll-hint.css";
import "./anime.js";
import { initMainSimpleBar, getPcMainScrollElement } from "./main-simplebar.js";
import { initMainScrollbar, syncMainScrollbar } from "./main-scrollbar.js";
import "./splide_setting.js"
import "./splide-extension-auto-scroll.js"
import "./dropdown.js"
import "./top.js"
import { initContactDevFill, isContactDevHost } from "./contact-dev-fill.js";

function isPcMainScroll() {
  return window.matchMedia("(min-width: 768px)").matches && $(".main").length > 0;
}

$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  if (href === "#") {
    if (isPcMainScroll()) {
      const el = getPcMainScrollElement();
      if (el) $(el).animate({ scrollTop: 0 }, speed, easing);
    } else {
      $("html, body").animate({ scrollTop: 0 }, speed, easing);
    }
    return false;
  }
  const $target = $(href);
  if (!$target.length) {
    return true;
  }
  const scrollMargin = parseInt($target.css("scroll-margin-top")) || 0;
  if (isPcMainScroll()) {
    const $scroll = $(getPcMainScrollElement());
    if ($scroll.length) {
      const nextTop =
        $scroll.scrollTop() +
        $target.offset().top -
        $scroll.offset().top -
        scrollMargin;
      $scroll.animate({ scrollTop: Math.max(0, nextTop) }, speed, easing);
    }
  } else {
    const position = $target.offset().top;
    $("html, body").animate({ scrollTop: position + scrollMargin }, speed, easing);
  }
  return false;
});

function onScrollUi() {
  updateTopBannerVisibility();
}

/** SP 固定 CV: MV 下あたりから表示。フッター到達で非表示 */
function getSpBannerMvEl() {
  return document.querySelector(".topMv, .svcMv, .cmpMv, .ctMv, .colMv");
}

function updateTopBannerVisibility() {
  const $banner = $(".js-cv-sp");
  const $footer = $(".js-footer-sp");
  if (!$banner.length) {
    return;
  }
  if (window.matchMedia("(min-width: 768px)").matches) {
    return;
  }

  const mv = getSpBannerMvEl();
  let pastMv = false;
  if (mv) {
    // MV 下端が画面上部〜1/4付近を超えたら出現（TOP / 下層共通）
    pastMv = mv.getBoundingClientRect().bottom <= window.innerHeight * 0.28;
  } else {
    // MV なしページは TOP MV 相当のスクロール量（SP 約 844px 前後）
    const fallback = Math.round(
      Math.min(window.innerWidth, 390) * (844 / 390)
    );
    pastMv = window.scrollY >= fallback;
  }

  const footerInView =
    $footer.length > 0 &&
    $footer[0].getBoundingClientRect().top < window.innerHeight;

  if (pastMv && !footerInView) {
    $banner.removeClass("is-none");
  } else {
    $banner.addClass("is-none");
  }
}

function bindPcMainScrollListener() {
  const el = getPcMainScrollElement();
  $(".main").off("scroll.simplebarMain");
  $(".main .simplebar-content-wrapper").off("scroll.simplebarMain");
  if (el) {
    $(el).on("scroll.simplebarMain", onScrollUi);
  }
  syncMainScrollbar();
}

$(function () {
  initMainSimpleBar(bindPcMainScrollListener);
  initMainScrollbar();
  $(window).on("load scroll", onScrollUi);
  bindPcMainScrollListener();
});
$(document).ready(function () {
  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function () {
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .header").toggleClass('is-navOn');
  });

  // リンククリック時の処理
  $('.js-nav-link').on('click', function (e) {
    const parent = $(this).closest('.header-navList__link');

    // --- SPで下層メニューを持つ場合はアコーディオンにする ---
    if (window.innerWidth <= 767 && parent.hasClass('has-sub')) {
      e.preventDefault(); // 遷移無効化
      parent.toggleClass('is-open');
      return; // メニューは閉じない
    }

    // --- それ以外（no-subリンクやPC）はメニューを閉じる ---
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .header").removeClass('is-navOn');
  });
});

function bindHeaderPhotoSlider() {
  var root = document.querySelector(".js-header-photo-slider");
  if (!root) return;
  var slides = root.querySelectorAll(".header-left__photoSlide");
  if (slides.length < 2) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  var index = 0;
  window.setInterval(function () {
    slides[index].classList.remove("is-active");
    index = (index + 1) % slides.length;
    slides[index].classList.add("is-active");
  }, 3000);
}

document.addEventListener("DOMContentLoaded", function () {
  bindHeaderPhotoSlider();
});

// FAQアコーディオンメニュー
$(function () {
  $(".js-accordion-title").on("click", function () {
    var $t = $(this);
    var $panel = $t.next();
    if (!$panel.length) {
      var $dt = $t.closest("dt");
      if ($dt.length) {
        $panel = $dt.next("dd");
      }
    }
    $panel.slideToggle(300);
    $t.toggleClass("close");
    var isOpen = !$t.hasClass("close");
    $t.attr("aria-expanded", isOpen);
    var $svcUnit = $t.closest(".svcFaq__unit");
    if ($svcUnit.length) {
      $svcUnit.toggleClass("svcFaq__unit--open", isOpen);
    }
  });
});

// フッターナビ アコーディオン（Figma 186:1195）
$(function () {
  $(".js-footer-acc").on("click", function () {
    var $btn = $(this);
    var $acc = $btn.closest(".footer__acc");
    var $panel = $acc.find(".footer__accPanel");
    var willOpen = !$acc.hasClass("is-open");

    $acc.toggleClass("is-open", willOpen);
    $btn.attr("aria-expanded", willOpen);
    if (willOpen) {
      $panel.prop("hidden", false).stop(true, true).slideDown(300);
    } else {
      $panel.stop(true, true).slideUp(300, function () {
        $panel.prop("hidden", true);
      });
    }
  });
});

// テスト環境（guildrive）のみ: お問い合わせダミー入力
if (isContactDevHost()) {
  const run = () => initContactDevFill();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
}
